import emailValidator from 'email-validator'
import { Field } from 'formik'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'

import { EmailField } from '../../field'

interface Props {
  name: string
  label: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
}

export function EmailInput(props: Props): JSX.Element {
  const { name, label, placeholder, required, disabled } = props
  const intl = useIntl()

  const validate = useCallback(
    (value: string | null): string | undefined => {
      if (required && (!value || !value.trim())) {
        return intl.formatMessage({ id: 'validation.requiredField' })
      }

      if (value && !emailValidator.validate(value)) {
        return intl.formatMessage({ id: 'emailInput.invalidEmail', defaultMessage: 'Virheellinen sähköpostiosoite' })
      }

      return undefined
    },
    [required, intl]
  )

  return (
    <Field
      disabled={disabled}
      component={EmailField}
      id={name}
      name={name}
      label={label}
      placeholder={placeholder}
      required={required}
      validate={validate}
    />
  )
}
